export const APP_START = "APP_START";

export const appStart = () => ({
  type: APP_START
});
